import { render } from "./LaborersAttendanceAdd.vue?vue&type=template&id=dd2630bc"
import script from "./LaborersAttendanceAdd.vue?vue&type=script&lang=js"
export * from "./LaborersAttendanceAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/laborers/attendance/cardReplace/LaborersAttendanceAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd2630bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd2630bc', __exports__)) {
    api.reload('dd2630bc', __exports__)
  }
  
  module.hot.accept("./LaborersAttendanceAdd.vue?vue&type=template&id=dd2630bc", () => {
    api.rerender('dd2630bc', render)
  })

}


export default __exports__